import { withFluid } from '@fluid-tailwind/tailwind-merge';
import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

export function cn(...args: ClassValue[]) {
	const t = extendTailwindMerge(withFluid);
	return t(clsx(args));
}
